<div hsg-modal-header *ngIf="data.title">
  <h3>{{ data.title }}</h3>
  <a class="modal-close-icon cancel" hsgModalClose>
    <span class="icon-cross"></span>
  </a>
</div>

<div hsg-modal-body>
  <div *ngIf="loading" class="loading">

  </div>
  <table class="variable" [class.title1]="variableJobTitles.length === 1"
    class="condensed form-group">
    <thead class="fixed-header">
      <tr class="shift-block-head">
        <ng-container *ngFor="let shiftBlock of shiftBlocks">
          <th class="census"></th>
          <th [colSpan]="variableJobTitles.length">{{ shiftBlock.description }}</th>
        </ng-container>
        <ng-container *ngIf="isRedrawn">
          <th class="census"></th>
          <th [colSpan]="variableJobTitles.length">{{ nextShiftBlock.description }}</th>
          <th class="census"></th>
        </ng-container>
      </tr>
      <tr>
        <ng-container *ngFor="let shiftBlock of shiftBlocks">
          <th class="census"></th>
          <th *ngFor="let jobTitle of variableJobTitles">
            {{ jobTitle.abbreviation }}
          </th>
        </ng-container>
        <ng-container *ngIf="isRedrawn">
          <th class="warning notification width" [colSpan]="variableJobTitles.length + 3">
            <span class="icon-notification"></span> The Staffing Grid for this block has recently been updated <wbr>and will be available to view starting next block.            
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody class="scrolling-body">
      <tr *ngFor="let row of staffingGrid; let i = index;">
        <ng-container *ngFor="let cell of row; let cellIndex = index;">
          <td class="census" *ngIf="cellIndex % variableJobTitles.length === 0">
            {{ maxCensus - i }}
          </td>
          <td>
            <input type="number" [name]="cell.id" [id]="cell.id" [value]="cell.value" [disabled]="true">
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>  
</div>

<div hsg-modal-footer>
  <button class="primary" [hsgModalClose]="true">
    {{ data.acceptText || 'OK' }}
  </button>
</div>